export default __webpack_public_path__ + "static/media/ls.2ac94099.svg";